// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__GPvFU","print":"styles_print__40N+U","save":"styles_save__JdH5h","load":"styles_load__QgAuQ"};